export default "__VITE_ASSET__C97ZIhWx__"